import styled from "styled-components";
import { InputWayTextCharElement } from "common/topic/input_way_text";
import { inputWayTextCharElementSValue } from "components/common/topic/TopicTextChars/TextCharEdit/TextCharEditPayload.logic";
import InputWayTextPlayElement from "../InputWayTextPlayElement";

export type InputWayTextPlayGroupProps = {
  elements: InputWayTextCharElement[];
};

const InputWayTextPlayGroup = ({ elements }: InputWayTextPlayGroupProps) => {
  return (
    <>
      <DivPlay>
        {elements.map((textCharElement: InputWayTextCharElement) => {
          const sValue = inputWayTextCharElementSValue(textCharElement);
          return (
            <>
              <InputWayTextPlayElement textCharElement={textCharElement} />
              {sValue.includes("\n") && <br />}
            </>
          );
        })}
      </DivPlay>
    </>
  );
};

const DivPlay = styled.div`
  margin-top: 2rem;
  font-size: 2rem;
  display: flex;
  gap: 0.5rem;
`;

export default InputWayTextPlayGroup;
